<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <form action="/catalog/default/index" ref="mainForm">
          <vue-instant
              v-model="searchValue"
              :suggestOnAllWords="true"
              :suggestions="searchSuggestions"
              :suggestion-attribute="suggestionAttribute"
              placeholder="Начните вводить запрос..."
              type="google"
              :show-autocomplete="true"
              @input="getSuggestions"
              @key-up:13="sendForm"
              @click-button="sendForm"
          ></vue-instant>
          <input type="hidden" name="search" v-model="searchValue">
        </form>
      </div>
    </div>
  </div>
</template>

<script>

  import 'vue-instant/dist/vue-instant.css';
  import VueInstant from 'vue-instant';
  import Vue from 'vue';

  Vue.use(VueInstant);

  Vue.component('vue-instant', VueInstant.VueInstant);

  import SphinxCatalog from '../services/SphinxCatalog';

  const COMPONENT_NAME = 'search-component';

  export default {
    name: COMPONENT_NAME,
    data() {
      return {
        searchValue: '',
        suggestionAttribute: 'title',
        searchSuggestions: []
      };
    },
    mounted() {
      let query = this.$route.query;
      if (query.hasOwnProperty('search')) {
        this.searchValue = query['search'];
      }
    },
    methods: {
          getSuggestions: _.debounce(function () {
              SphinxCatalog.getItemsByText(this.searchValue).then((response) => this.searchSuggestions = response);
          }, 1000),
          sendForm() {
              this.$refs.mainForm.submit();
          }
      }
  }
</script>

<style lang="scss">
  .searchbox.sbx-google {
    width: 100%;
    margin-bottom: 15px;
  }
  .el-input-group__append {
    .vue-instant__suggestions {
      width: auto;
    }
  }
</style>